/**
 * Include your custom JavaScript here.
 */

document.addEventListener('DOMContentLoaded', () => {
  // ---------------------------------------------------------------------------
  // 1. Color Swatch & SKU Updater
  // ---------------------------------------------------------------------------
  setTimeout(() => {
    function getSelectedOptions(card) {
      const optionRadios = card.querySelectorAll('.color-swatch__radio:checked');
      const selected = [];

      optionRadios.forEach((radio) => {
        selected.push(radio.value);
      });

      return selected;
    }

    function getMatchingVariant(card, selectedOptions) {
      const variantsJson = card.getAttribute('data-variants-json');
      if (!variantsJson) return null;

      const variants = JSON.parse(variantsJson);

      return variants.find((variant) => {
        return selectedOptions.every((value, index) => {
          return variant[`option${index + 1}`] === value;
        });
      });
    }

    function updateSKU(card) {
      const selectedOptions = getSelectedOptions(card);
      const matchingVariant = getMatchingVariant(card, selectedOptions);

      if (matchingVariant) {
        const skuSpan = card.querySelector('.product-item__sku-value');
        if (skuSpan) {
          skuSpan.textContent = matchingVariant.sku || '';
          skuSpan.classList.add('sku-flash');
          setTimeout(() => skuSpan.classList.remove('sku-flash'), 600);
        }
      }
    }

    document.querySelectorAll('.product-item').forEach((card) => {
      const radios = card.querySelectorAll('.color-swatch__radio');
      radios.forEach((radio) => {
        radio.addEventListener('change', () => updateSKU(card));
      });

      // Fire on load
      updateSKU(card);
    });
  }, 100);

  // ---------------------------------------------------------------------------
  // 2. Main Add-To-Cart Button Loading ("...") & Success ("Added!") Handler
  // ---------------------------------------------------------------------------
  
  // Intercept cart form submissions globally
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const button = form.querySelector('button[type="submit"], [data-action="add-to-cart"], .product-form__add-button, .buy-button button');

    // Skip complementary slider buttons handled separately
    if (!button || button.classList.contains('custom-comp-btn')) {
      return;
    }

    // Save the original button text if not already saved
    if (!button.getAttribute('data-original-text')) {
      const currentText = button.innerText.trim() || button.textContent.trim();
      if (currentText !== '...' && currentText !== 'Added!') {
        button.setAttribute('data-original-text', currentText);
      } else {
        button.setAttribute('data-original-text', 'Add to cart');
      }
    }

    // Phase 1: Immediate Loading State
    button.innerText = '...';

    // Phase 2: Show "Added!" state shortly after click/submission
    setTimeout(() => {
      button.innerText = 'Added!';
      button.classList.add('custom-comp-btn--success');
    }, 400);

    // Phase 3: Guaranteed Reset back to original label ("Add to cart")
    setTimeout(() => {
      const originalText = button.getAttribute('data-original-text') || 'Add to cart';
      button.innerText = originalText;
      button.classList.remove('custom-comp-btn--success');
    }, 2500);
  });

  // Backup listener for theme's native "product:added" custom event
  document.addEventListener('product:added', (event) => {
    const button = document.querySelector('form[action*="/cart/add"] button[type="submit"], .buy-button button');
    if (button) {
      const originalText = button.getAttribute('data-original-text') || 'Add to cart';
      button.innerText = 'Added!';
      button.classList.add('custom-comp-btn--success');

      setTimeout(() => {
        button.innerText = originalText;
        button.classList.remove('custom-comp-btn--success');
      }, 2000);
    }
  });
});